import { useRef, useState } from "react";
import Button from "../../../../../Custom/Button/Button";
import deleteImg from "../../../../../../picture/delete.png";
import LatinicaWarningModal from "../../LatinicaWarningModal";
import { useGlobalContext } from "../../../../../../Context/Context";

const styles = {
  button: {
    padding: "10px 20px",
  },
  input: { width: "100%", padding: "10px", fontSize: "14px" },
};

const Pocetna = ({
  handleConfirm,
  handleCancel,
  newMere,
  setNewMere,
  setCurrentState,
}) => {
  const [openLatinicaModal, setOpenLatinicaModal] = useState(false);

  const textareaRefs = useRef({});

  const { dictionary } = useGlobalContext();

  const handleChangeTitle = (id, value) => {
    setNewMere((prev) =>
      prev.map((mera) => (mera.id === id ? { ...mera, title: value } : mera)),
    );
  };

  const handleChangeText = (id, value) => {
    setNewMere((prev) =>
      prev.map((mera) => (mera.id === id ? { ...mera, text: value } : mera)),
    );
  };

  const handleKeyDown = (e, id) => {
    const key = e.key;
    if (/^[A-Za-z]$/.test(key)) {
      e.preventDefault();
      setOpenLatinicaModal(true);
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const textarea = textareaRefs.current[id];
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      setNewMere((prev) =>
        prev.map((mera) => {
          if (mera.id !== id) return mera;

          const before = mera.text.substring(0, start);
          const after = mera.text.substring(end);
          const newText = before + "\n- " + after;

          return { ...mera, text: newText };
        }),
      );

      requestAnimationFrame(() => {
        const pos = start + 3;
        textarea.setSelectionRange(pos, pos);
      });
    }
  };

  const handleKeyDownTitle = (e) => {
    const key = e.key;
    if (/^[A-Za-z]$/.test(key)) {
      e.preventDefault();
      setOpenLatinicaModal(true);
    }
  };

  const handleDelete = (id) => {
    setNewMere((prev) => prev.filter((p) => p.id !== id));
  };

  const handleUgradi = () => {
    setCurrentState("UGRADI");
  };

  const handleUcitaj = () => {
    setCurrentState("UCITAJ");
  };

  const handleCancelLatinica = () => setOpenLatinicaModal(false);

  if (!newMere) return null;

  return (
    <>
      <div style={{ maxHeight: "600px", overflowY: "auto" }}>
        {newMere.map((mera) => (
          <div
            key={mera.id}
            style={{ marginBottom: "10px", display: "flex", gap: "5px" }}
          >
            <div style={{ width: "100%" }}>
              <input
                value={mera.title}
                onChange={(e) => handleChangeTitle(mera.id, e.target.value)}
                onKeyDown={handleKeyDownTitle}
                style={styles.input}
              />
              <textarea
                ref={(el) => (textareaRefs.current[mera.id] = el)}
                value={mera.text}
                onChange={(e) => handleChangeText(mera.id, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, mera.id)}
                rows={10}
                style={styles.input}
              />
            </div>
            <div
              onClick={() => handleDelete(mera.id)}
              style={{ cursor: "pointer" }}
            >
              <img src={deleteImg} style={{ width: "20px" }} />
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <div onClick={handleCancel} style={{height: "40px" }}>
          <Button activation={true} style={styles.button}>
            <span style={{width: "10vw", height: "40px", fontWeight: "bold",alignContent: "center"}}> {dictionary["odustani"]}</span>
           
          </Button>
        </div>
        <div onClick={handleUcitaj} style={{height: "40px"  }}>
          <Button activation={true} style={styles.button}>
            <span style={{width: "10vw", height: "40px", fontWeight: "bold",alignContent: "center"}}> {dictionary["ucitaj"]}</span>
          </Button>
        </div>
        <div onClick={handleUgradi} style={{ height: "40px"  }}>
          <Button activation={true} style={styles.button}>
             <span style={{width: "10vw", height: "40px", fontWeight: "bold",alignContent: "center"}}> {dictionary["ugradi"]}</span>
          </Button>
        </div>
        <div onClick={() => handleConfirm(newMere)} style={{ height: "40px"  }}>
          <Button activation={true} style={styles.button}>
             <span style={{width: "10vw", height: "40px", fontWeight: "bold",alignContent: "center"}}> {dictionary["sacuvaj"]}</span>
          </Button>
        </div>
      </div>

      {openLatinicaModal && (
        <LatinicaWarningModal handleCancel={handleCancelLatinica} />
      )}
    </>
  );
};

export default Pocetna;
